var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assessment-detail"},[_c('elsa-tree',{attrs:{"accordion":"","icon-class":"tree-icon","default-expand-all":"","data":_vm.treeData},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var node = ref.node;
return [_c('span',{class:node.data.options.titleClassArray},[_vm._v(" "+_vm._s(node.data.label)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }